import { api } from '../../http';
import { ElementUI } from '../../types/interfaces';

import Api from './api';
import IElementUIsApi from './interfaces/elementUIsApi';

class ElementUIsApi extends Api<ElementUI> implements IElementUIsApi {
  constructor(abortController: AbortController) {
    super('elementui/', abortController);
  }

  async getCurrentUserElementCodes() {
    const apiCallResult = await api.get<ElementUI[]>(
      'elementui/getCurrentUserElementCodes',
      { signal: this._abortController.signal }
    );
    return apiCallResult?.data;
  }
}

export default ElementUIsApi;
